import { useContext } from "react";
import { useLocStore } from "../../../localization";
import { LocContext } from "../../../localization/LocContext";
import { persistAndStopPropagation } from "../../../utils/util";
import {
  useKeycloakAuth,
  AdminContext,
} from "../../adminSettings/AdminContext";

export function useKeycloakAuthMenuItem() {
  const L = useLocStore(LocContext.PROFILE);
  const keycloakAuth = useKeycloakAuth();
  const adminContext = useContext(AdminContext);

  return {
    label: L.id("kc001").loc("Bruk Keycloak autentisering"),
    icon: keycloakAuth ? "pi pi-fw pi-check-circle" : "pi pi-fw pi-circle",
    className: "vpn-item vpn-only",
    onClick: (evt) => {
      adminContext.setUseKeycloakAuth(!keycloakAuth);
      evt.preventDefault();
      persistAndStopPropagation(evt);
    },
  };
}
